var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#71778a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -490)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 30,
    transform: "translate(23 490)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.018,27.964H1.786A1.782,1.782,0,0,1,0,26.188V3.551A1.781,1.781,0,0,1,1.786,1.777H2.67V1.432c0-.79.4-1.432.893-1.432h6.671c.492,0,.893.643.893,1.432v.346h.892a1.777,1.777,0,0,1,1.777,1.774V26.188A1.778,1.778,0,0,1,12.018,27.964ZM5.372,16.52v0l-.7,5.12a.472.472,0,0,0,.467.534.449.449,0,0,0,.106-.012.471.471,0,0,0,.291-.2l5.628-8.7a.468.468,0,0,0-.011-.526.473.473,0,0,0-.493-.188L8.684,13l.548-5.1a.473.473,0,0,0-.869-.3L2.9,16.262a.467.467,0,0,0,.015.524.472.472,0,0,0,.491.186l1.962-.451Z",
    transform: "translate(28.998 491.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryGrey);
export default __webpack_public_path__ + "static/media/battery_grey.c21c0d47641717412100b3495cb43e92.svg";
export { ForwardRef as ReactComponent };